module.exports = __webpack_public_path__ + "static/media/r31.50062d7e.jpg";